export const translationStrings = [
  'common.buttons.logout',
  'error.page.forbidden.message',
  'error.page.forbidden.back.to.homepage.button',
] as const;
